/* =========================================
   MIXAT CUSTOM JS
   Heritage 4.1.4 stable version
========================================= */


/* =========================================
   SCROLL TO TOP
========================================= */

document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('scrollToTop');

  if (!btn) return;

  const toggleButton = function () {
    btn.style.display = window.scrollY > 300 ? 'block' : 'none';
  };

  toggleButton();

  window.addEventListener('scroll', toggleButton, {
    passive: true
  });

  btn.addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});


/* =========================================
   FAQ - DEFAULT PAGE
========================================= */

document.addEventListener('DOMContentLoaded', function () {
  const firstFAQ = document.querySelector(
    '.accordion .details'
  );

  if (firstFAQ) {
    firstFAQ.setAttribute('open', '');
  }
});


/* =========================================
   PRODUCT PAGE FAQ
========================================= */

document.addEventListener('DOMContentLoaded', function () {
  if (
    !window.location.pathname.includes('/products/')
  ) {
    return;
  }

  const accordions =
    document.querySelectorAll('.accordion');

  if (accordions.length <= 1) return;

  const secondAccordion = accordions[1];

  document
    .querySelectorAll('.accordion .details')
    .forEach(function (detail) {
      detail.removeAttribute('open');
    });

  const firstDetail =
    secondAccordion.querySelector('.details');

  if (firstDetail) {
    firstDetail.setAttribute('open', '');
  }
});


/* =========================================
   EXTERNAL LINKS
========================================= */

document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('a[href^="http"]')
    .forEach(function (link) {
      try {
        const url = new URL(
          link.href,
          window.location.href
        );

        if (
          url.hostname !==
          window.location.hostname
        ) {
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        }
      } catch (error) {
        /* Ignore invalid URLs */
      }
    });
});


/* =========================================
   EXTERNAL LINK CLICK FALLBACK
========================================= */

document.addEventListener('click', function (event) {
  const link = event.target.closest('a[href]');

  if (!link) return;


  /* Judge.me / external widgets */

  if (
    link.closest('.jdgm-widget') ||
    link.classList.contains('jdgm-write-review') ||
    link.hasAttribute('data-jdgm-link') ||
    link.dataset.jdgm === 'true'
  ) {
    return;
  }


  const href =
    link.getAttribute('href') || '';


  /* Ignore special protocols */

  if (
    href === '#' ||
    href.startsWith('javascript:') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:')
  ) {
    return;
  }


  /* Only absolute HTTP(S) links */

  if (!/^https?:\/\//i.test(href)) {
    return;
  }


  let url;

  try {
    url = new URL(
      href,
      window.location.href
    );
  } catch (error) {
    return;
  }


  /* Internal links stay normal */

  if (
    url.hostname ===
    window.location.hostname
  ) {
    return;
  }


  /* External link */

  event.preventDefault();

  window.open(
    url.toString(),
    '_blank',
    'noopener,noreferrer'
  );
});

/* =========================================
   MIXAT TESTIMONIAL SLIDER
   Responsive page-based slider
========================================= */

function initMixatTestimonialSlider() {

  const slider = document.querySelector(
    '[data-mixat-testimonial-slider]'
  );

  if (!slider) return;


  const viewport = slider.querySelector(
    '.mixat-testimonials__viewport'
  );

  const track = slider.querySelector(
    '.mixat-testimonials__track'
  );

  const prevButton = slider.querySelector(
    '.mixat-testimonials__arrow--prev'
  );

  const nextButton = slider.querySelector(
    '.mixat-testimonials__arrow--next'
  );

  const dotsContainer = slider.querySelector(
    '.mixat-testimonials__dots'
  );


  if (
    !viewport ||
    !track ||
    !prevButton ||
    !nextButton ||
    !dotsContainer
  ) {
    return;
  }


  /* -----------------------------------------
     ORIGINAL TESTIMONIALS
  ----------------------------------------- */

  const originalSlides = Array.from(
    track.querySelectorAll('.mixat-testimonial')
  );


  if (!originalSlides.length) return;


  let currentPage = 0;
  let currentPerPage = 0;
  let pages = [];

  let touchStartX = 0;
  let touchEndX = 0;


  /* =========================================
     RESPONSIVE NUMBER
  ========================================= */

  function getPerPage() {

    const width = window.innerWidth;


    if (width <= 749) {
      return 1;
    }


    if (width <= 989) {
      return 2;
    }


    return 3;
  }


  /* =========================================
     BUILD PAGES
  ========================================= */

  function buildPages() {

    const perPage = getPerPage();


    /*
      Ne rebuild-ujemo ako breakpoint
      nije promenjen.
    */

    if (
      perPage === currentPerPage &&
      pages.length
    ) {
      return;
    }


    currentPerPage = perPage;


    /*
      Izvadi sve testimonijale iz
      postojećih page wrappera.
    */

    const slides = Array.from(
      track.querySelectorAll(
        '.mixat-testimonial'
      )
    );


    track.innerHTML = '';


    pages = [];


    /*
      Grupisanje:

      Desktop:
      [1 2 3] [4 5 6] ...

      Tablet:
      [1 2] [3 4] ...

      Mobile:
      [1] [2] [3] ...
    */

    for (
      let i = 0;
      i < slides.length;
      i += perPage
    ) {

      const page =
        document.createElement('div');


      page.className =
        'mixat-testimonials__page';


      const group =
        slides.slice(
          i,
          i + perPage
        );


      group.forEach(function (slide) {

        page.appendChild(slide);

      });


      track.appendChild(page);

      pages.push(page);

    }


    /*
      Ako smo bili npr. na page 8
      na mobile, pa prešli na desktop,
      vrati indeks u validan range.
    */

    currentPage = Math.min(
      currentPage,
      pages.length - 1
    );


    createDots();

    moveSlider(false);

  }


  /* =========================================
     DOTS
  ========================================= */

  function createDots() {

    dotsContainer.innerHTML = '';


    pages.forEach(function (_, index) {

      const dot =
        document.createElement('button');


      dot.type = 'button';

      dot.className =
        'mixat-testimonials__dot';


      dot.setAttribute(
        'aria-label',
        'Stranica ' + (index + 1)
      );


      dot.addEventListener(
        'click',
        function () {

          currentPage = index;

          moveSlider(true);

        }
      );


      dotsContainer.appendChild(dot);

    });

  }


  /* =========================================
     MOVE
  ========================================= */

  function moveSlider(animate = true) {

    if (!pages.length) return;


    currentPage = Math.max(
      0,
      Math.min(
        currentPage,
        pages.length - 1
      )
    );


    /*
      KLJUČ:

      Svaka page je TAČNO 100%
      širine viewporta.

      Zato:

      page 0 = 0%
      page 1 = -100%
      page 2 = -200%

      Nema pixel matematike.
    */

    if (!animate) {

      track.style.transition = 'none';

    } else {

      track.style.transition =
        'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)';

    }


    track.style.transform =
      `translate3d(-${currentPage * 100}%, 0, 0)`;


    updateControls();


    if (!animate) {

      requestAnimationFrame(function () {

        requestAnimationFrame(function () {

          track.style.transition =
            'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)';

        });

      });

    }

  }


  /* =========================================
     CONTROLS
  ========================================= */

  function updateControls() {

    prevButton.disabled =
      currentPage === 0;


    nextButton.disabled =
      currentPage ===
      pages.length - 1;


    const dots =
      dotsContainer.querySelectorAll(
        '.mixat-testimonials__dot'
      );


    dots.forEach(function (dot, index) {

      const active =
        index === currentPage;


      dot.classList.toggle(
        'is-active',
        active
      );


      dot.setAttribute(
        'aria-current',
        active ? 'true' : 'false'
      );

    });

  }


  /* =========================================
     PREVIOUS
  ========================================= */

  prevButton.addEventListener(
    'click',
    function () {

      if (currentPage <= 0) return;


      currentPage--;

      moveSlider();

    }
  );


  /* =========================================
     NEXT
  ========================================= */

  nextButton.addEventListener(
    'click',
    function () {

      if (
        currentPage >=
        pages.length - 1
      ) {
        return;
      }


      currentPage++;

      moveSlider();

    }
  );


  /* =========================================
     SWIPE
  ========================================= */

  viewport.addEventListener(
    'touchstart',
    function (event) {

      touchStartX =
        event.changedTouches[0].clientX;

    },
    {
      passive: true
    }
  );


  viewport.addEventListener(
    'touchend',
    function (event) {

      touchEndX =
        event.changedTouches[0].clientX;


      const difference =
        touchStartX - touchEndX;


      if (
        Math.abs(difference) < 50
      ) {
        return;
      }


      /*
        Swipe left
      */

      if (difference > 0) {

        if (
          currentPage <
          pages.length - 1
        ) {

          currentPage++;

          moveSlider();

        }

      }


      /*
        Swipe right
      */

      else {

        if (currentPage > 0) {

          currentPage--;

          moveSlider();

        }

      }

    },
    {
      passive: true
    }
  );


  /* =========================================
     RESIZE
  ========================================= */

  let resizeTimer;


  window.addEventListener(
    'resize',
    function () {

      clearTimeout(resizeTimer);


      resizeTimer =
        setTimeout(function () {

          const newPerPage =
            getPerPage();


          /*
            Rebuild samo kada prelazimo
            breakpoint.
          */

          if (
            newPerPage !==
            currentPerPage
          ) {

            buildPages();

          } else {

            moveSlider(false);

          }

        }, 100);

    }
  );


  /* =========================================
     INITIALIZE
  ========================================= */

  buildPages();

}


/* =========================================
   PAGE LOAD
========================================= */

if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    initMixatTestimonialSlider
  );

} else {

  initMixatTestimonialSlider();

}

